import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../environments/environment';
import { APP_ROUTES } from './app-routes';
import { initializeApp } from './app.initializer';
import { LoaderInterceptor } from './shared/interceptors/loader.interceptor';
import { appReducers } from './shared/store/reducers/app.reducers';

export function createTranslateLoader(httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(httpBackend, [
    './assets/quid-i18n/',
    './assets/i18n/',
    './assets/up-i18n/',
  ]);
}

export function getAppProviders() {
  return [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    { provide: Window, useValue: window },
    provideAppInitializer(initializeApp),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpBackend],
      },
    }),
    importProvidersFrom(
      StoreModule.forRoot(appReducers),
      ...(environment.production
        ? []
        : [
            StoreDevtoolsModule.instrument({
              maxAge: 25,
              logOnly: environment.production,
            }),
          ]),
    ),
  ];
}
